import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import RightTable from './RightTable';
import LeftTable from './LeftTable';
import Grid from '@mui/material/Grid';
import pullAll from "lodash/pullAll"
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import Typography from '@mui/material/Typography';


const MpgClientAccountTransferListDialog = ({ open, setOpen, leftTableDataToPop, rightTableDataToPop, grabRightTableData, transferDialogTitle, leftTableTitle, rightTableTitle,cmsData}) => {
    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    }
    /** */
    const [leftTableData, setLeftTableData] = useState([])
    const [rightTableData, setRightTableData] = useState([])

    useEffect(() => {
        if (!!rightTableDataToPop && !!rightTableDataToPop.length) {
            setRightTableData(rightTableDataToPop)
        }
    }, [rightTableDataToPop])

    useEffect(() => {
        if (!!leftTableDataToPop && !!leftTableDataToPop.length) {
            setLeftTableData(leftTableDataToPop)
        }
    }, [leftTableDataToPop])

    /** */
    const [rightTableRowSelection, setRightTableRowSelection] = useState({});
    const [leftTableRowSelection, setLeftTableRowSelection] = useState({});

    /** */
    const [selectedItemsInLeft, setSelectedItemsInLeft] = useState([])
    const [selectedItemsInRight, setSelectedItemsInRight] = useState([])

    const trasferToRightHandler = () => {

        /**transferring actual entries to right */
        if (!!rightTableData && !!rightTableData.length) {
            setRightTableData([...rightTableData, ...selectedItemsInLeft])
        } else {
            setRightTableData(selectedItemsInLeft)
        }

        /**we do not remover trasfer entries from left instead we disable selection of those */
        /**to avoid duplicate selection we disable selection of tranfered row*/

        /**clearing check box in left table on trasfer */
        setLeftTableRowSelection({})
    }


    const trasferToLeftHandler = () => {
        /**here we r not trasferring actual item. We unable check box which can be selectable. */

        /**removing selected items from right table */
        const rightCopy = [...rightTableData]
        pullAll(rightCopy, selectedItemsInRight)
        setRightTableData(rightCopy)

        /**clearing check box in right table on trasfer */
        setRightTableRowSelection({})
    }

    const fetchCommonComponentCMSLabel=(key)=>{
        if(cmsData?.Components && cmsData?.Components["CommonComponent"]){
           const clientSubAccountGroupsListCMSDataLabel=cmsData?.Components["CommonComponent"];
              return returnLabel(clientSubAccountGroupsListCMSDataLabel?.Labels, key)
        }
        return '';
      }
      
      const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
      }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullScreen
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography align='center' sx={{ fontWeight: 'bolder', fontSize: '20px' }}>
                    {transferDialogTitle}
                </Typography>

                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>

                <Grid container spacing={1}>
                    {/**left table */}

                    <Grid item xs={12} sm={5}>
                        <Typography variant="subtitle2" align='center' sx={{ fontWeight: 'bolder' }}>
                            {leftTableTitle}
                        </Typography>
                        <LeftTable
                            leftTableData={leftTableData}

                            setSelectedItemsInLeft={setSelectedItemsInLeft}

                            leftTableRowSelection={leftTableRowSelection}
                            setLeftTableRowSelection={setLeftTableRowSelection}

                            rightTableData={rightTableData}
                            cmsData={cmsData && cmsData}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >

                            <Button
                                variant="outlined"
                                onClick={() => {
                                    trasferToRightHandler();
                                }}
                                disabled={!!selectedItemsInRight.length}
                            ><KeyboardDoubleArrowRightIcon /></Button>
                            <br />
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    trasferToLeftHandler();
                                }}
                                disabled={!!selectedItemsInLeft.length}
                            ><KeyboardDoubleArrowLeftIcon /></Button>
                        </Grid>

                    </Grid>
                    {/**right table */}
                    <Grid item xs={12} sm={5}>
                        <Typography variant="subtitle2" align='center' sx={{ fontWeight: 'bolder' }}>
                            {rightTableTitle}
                        </Typography>
                        <RightTable
                            rightTableData={rightTableData}
                            setSelectedItemsInRight={setSelectedItemsInRight}

                            rightTableRowSelection={rightTableRowSelection} setRightTableRowSelection={setRightTableRowSelection}
                            cmsData={cmsData && cmsData}
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button
                    type='button'
                    onClick={() => {
                        grabRightTableData(rightTableData || [])
                        handleClose()
                    }}
                >{fetchCommonComponentCMSLabel('Common.Add')}</Button>
                <Button onClick={handleClose}>{fetchCommonComponentCMSLabel('Common.Cancel')}</Button>
            </DialogActions>

        </Dialog >
    )
}
export default MpgClientAccountTransferListDialog